var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "page-regional-screen" }, [
    _c("div", { staticClass: "page-header" }, [
      _c("div", {
        staticClass: "screen-name zhenyan-node",
        domProps: { textContent: _vm._s(_vm.info.name) }
      }),
      _c("div", { staticClass: "header-right" }, [
        _c("div", [
          _vm.info.docUrl
            ? _c(
                "div",
                { staticClass: "record-box", on: { click: _vm.openDoc } },
                [_vm._v("养殖记录")]
              )
            : _vm._e()
        ]),
        _c("div", { staticClass: "time-box" }, [
          _c("div", {
            staticClass: "time zhenyan-node",
            domProps: { textContent: _vm._s(_vm.time) }
          }),
          _c("div", { staticClass: "day" }, [
            _c("b", {
              staticClass: "date",
              domProps: { textContent: _vm._s(_vm.date) }
            }),
            _c("b", { domProps: { textContent: _vm._s(_vm.day) } })
          ])
        ]),
        _c("div", { staticClass: "weather-box" }, [
          _c("img", {
            attrs: {
              src:
                _vm.ossHost +
                "file/weather/" +
                (_vm.weatherInfo.code || 1) +
                "@2x.png",
              alt: ""
            }
          }),
          _c("div", {
            staticClass: "city-name",
            domProps: { textContent: _vm._s(_vm.info.city) }
          }),
          _c("div", { staticClass: "tem" }, [
            _c("b", {
              domProps: { textContent: _vm._s(_vm.weatherInfo.temperature) }
            }),
            _vm._v("°C")
          ])
        ])
      ])
    ]),
    _c("div", { staticClass: "page-content" }, [
      _c("div", { staticClass: "content-top" }, [
        _c("div", { staticClass: "regional-info" }, [
          _c("div", { staticClass: "info-box" }, [
            _vm._m(0),
            _c("div", { staticClass: "info-item1" }, [
              _c("div", { staticClass: "item-box first-child" }, [
                _c("img", {
                  attrs: { src: _vm.ossHost + "img/gov_icon5.png", alt: "" }
                }),
                _c("div", { staticClass: "item-count-box" }, [
                  _c(
                    "b",
                    { staticClass: "item-count zhenyan-node" },
                    [
                      _c("animate-number", {
                        key: _vm.info.totalAdminCount,
                        ref: "totalAdminCount",
                        attrs: {
                          from: "0",
                          to: _vm.info.totalAdminCount || 0,
                          duration: _vm.duration,
                          easing: "easeOutQuad"
                        }
                      })
                    ],
                    1
                  ),
                  _c("b", [_vm._v("人")])
                ]),
                _c("div", { staticClass: "item-text" }, [_vm._v("管理员数")])
              ]),
              _c("div", { staticClass: "item-box" }, [
                _c("img", {
                  attrs: { src: _vm.ossHost + "img/gov_icon4.png", alt: "" }
                }),
                _c("div", { staticClass: "item-count-box" }, [
                  _c(
                    "b",
                    { staticClass: "item-count zhenyan-node" },
                    [
                      _c("animate-number", {
                        key: _vm.info.totalPoolCount,
                        ref: "totalPoolCount",
                        attrs: {
                          from: "0",
                          to: _vm.info.totalPoolCount,
                          duration: _vm.duration,
                          easing: "easeOutQuad"
                        }
                      })
                    ],
                    1
                  ),
                  _c("b", [_vm._v("个")])
                ]),
                _c("div", { staticClass: "item-text" }, [_vm._v("总鱼塘数")])
              ])
            ]),
            _c("div", { staticClass: "info-item2" }, [
              _c("div", { staticClass: "item-box first-child" }, [
                _c("img", {
                  attrs: { src: _vm.ossHost + "img/gov_icon7.png", alt: "" }
                }),
                _c("div", { staticClass: "item-count-box" }, [
                  _c(
                    "b",
                    { staticClass: "item-count zhenyan-node" },
                    [
                      _c("animate-number", {
                        key: _vm.info.totalPoolAcreage,
                        ref: "totalPoolAcreage",
                        attrs: {
                          from: "0",
                          to: _vm.info.totalPoolAcreage,
                          duration: _vm.duration,
                          easing: "easeOutQuad"
                        }
                      })
                    ],
                    1
                  ),
                  _c("b", [_vm._v("亩")])
                ]),
                _c("div", { staticClass: "item-text" }, [_vm._v("养殖总面积")])
              ]),
              _c("div", { staticClass: "item-box" }, [
                _c("img", {
                  attrs: { src: _vm.ossHost + "img/gov_icon6.png", alt: "" }
                }),
                _c("div", { staticClass: "item-count-box" }, [
                  _c(
                    "b",
                    { staticClass: "item-count zhenyan-node" },
                    [
                      _c("animate-number", {
                        key: _vm.warningInfo.totalOnlineCount,
                        ref: "totalOnlineNum",
                        attrs: {
                          from: "0",
                          to: _vm.warningInfo.totalOnlineCount,
                          duration: _vm.duration,
                          easing: "easeOutQuad"
                        }
                      })
                    ],
                    1
                  ),
                  _c("b", [_vm._v("台")])
                ]),
                _c("div", { staticClass: "item-text" }, [_vm._v("在线设备数")])
              ])
            ]),
            _vm._m(1)
          ])
        ]),
        _c("div", { staticClass: "pond-info" }, [
          _c("div", { staticClass: "info-box" }, [
            _vm._m(2),
            _c("div", { staticClass: "pond-info-item" }, [
              _c("div", { staticClass: "item-title" }, [_vm._v("鱼塘溶氧")]),
              _c("div", { staticClass: "item-text" }, [
                _vm._v("溶氧正常 "),
                _c(
                  "b",
                  { staticClass: "zhenyan-node" },
                  [
                    _c("animate-number", {
                      key: _vm.warningInfo.oxyFormalCount,
                      ref: "ryOnlineCount",
                      attrs: {
                        from: "0",
                        to: _vm.warningInfo.oxyFormalCount,
                        duration: _vm.duration,
                        easing: "easeOutQuad"
                      }
                    })
                  ],
                  1
                ),
                _c("b", [_vm._v("个")])
              ]),
              _c("div", { staticClass: "item-text ry-text" }, [
                _vm._v("溶氧过低 "),
                _c(
                  "b",
                  { staticClass: "zhenyan-node" },
                  [
                    _c("animate-number", {
                      key: _vm.warningInfo.lowDissolvedOxygenCount,
                      ref: "lowDissolvedOxygenCount",
                      attrs: {
                        from: "0",
                        to: _vm.warningInfo.lowDissolvedOxygenCount,
                        duration: _vm.duration,
                        easing: "easeOutQuad"
                      }
                    })
                  ],
                  1
                ),
                _c("b", [_vm._v("个")])
              ])
            ]),
            _c("div", { staticClass: "pond-info-item pond-device-item" }, [
              _c("div", { staticClass: "item-title" }, [_vm._v("设备")]),
              _c("div", { staticClass: "item-text" }, [
                _vm._v("正常 "),
                _c(
                  "b",
                  { staticClass: "zhenyan-node" },
                  [
                    _c("animate-number", {
                      key: _vm.warningInfo.totalFormalCount,
                      ref: "totalFormalCount",
                      attrs: {
                        from: "0",
                        to: _vm.warningInfo.totalFormalCount,
                        duration: _vm.duration,
                        easing: "easeOutQuad"
                      }
                    })
                  ],
                  1
                ),
                _c("b", [_vm._v("台")])
              ]),
              _c("div", { staticClass: "item-text device-text" }, [
                _vm._v("告警 "),
                _c(
                  "b",
                  { staticClass: "zhenyan-node" },
                  [
                    _c("animate-number", {
                      key: _vm.warningInfo.warnCount,
                      ref: "warnCount",
                      attrs: {
                        from: "0",
                        to: _vm.warningInfo.warnCount,
                        duration: _vm.duration,
                        easing: "easeOutQuad"
                      }
                    })
                  ],
                  1
                ),
                _c("b", [_vm._v("台")])
              ]),
              _c("div", { staticClass: "line" })
            ])
          ])
        ])
      ]),
      _c("div", { staticClass: "content-bottom" }, [
        _c("div", { staticClass: "canvas-box bottom-box" }, [
          _c("div", { staticClass: "video-monitor" }, [
            _c(
              "div",
              { class: { "slider-box": true, loading: _vm.loading } },
              [
                _c(
                  "el-carousel",
                  { attrs: { interval: 40000, type: "always" } },
                  _vm._l(_vm.info.yddIpcList, function(item, index) {
                    return _c("el-carousel-item", { key: index }, [
                      _c(
                        "div",
                        {
                          staticClass: "slider-item",
                          staticStyle: { "min-height": "0.7rem" }
                        },
                        [
                          _c("span", { staticClass: "title" }, [
                            _vm._v(_vm._s(item.name))
                          ]),
                          _c("canvas", {
                            staticClass: "canvas-player",
                            attrs: {
                              "data-ipc-id": item.ipcId,
                              id: "video-" + index,
                              width: "1000",
                              height: "500"
                            }
                          })
                        ]
                      )
                    ])
                  }),
                  1
                ),
                !_vm.info.yddIpcList.length
                  ? _c("div", { staticClass: "empty-box" }, [
                      _vm._v("暂无监控画面")
                    ])
                  : _vm._e()
              ],
              1
            )
          ]),
          _c("div", { staticClass: "water-quality" }, [
            _c("div", { staticClass: "nh3-chart-box" }, [
              _c("div", { staticClass: "chart-title" }, [_vm._v("氨氮")]),
              _c("div", {
                staticClass: "NH3-N-chart",
                attrs: { id: "NH3-N-chart" }
              }),
              !_vm.pondInfo.nh3_NView.length
                ? _c("div", { staticClass: "empty-box" }, [
                    _vm._v("暂无氨氮数据")
                  ])
                : _vm._e()
            ]),
            _c("div", { staticClass: "no2-chart-box" }, [
              _c("div", { staticClass: "chart-title" }, [_vm._v("亚盐")]),
              _c("div", {
                staticClass: "NO2-chart",
                attrs: { id: "NO2-chart" }
              }),
              !_vm.pondInfo.no2_NView.length
                ? _c("div", { staticClass: "empty-box" }, [
                    _vm._v("暂无亚盐数据")
                  ])
                : _vm._e()
            ])
          ])
        ]),
        _c("div", { staticClass: "swiper-box bottom-box" }, [
          _c(
            "div",
            {
              staticClass: "swiper-item-box",
              style: { marginLeft: "-" + 0 * 100 + "%" }
            },
            [
              _c("div", { staticClass: "item-box" }, [
                _c("div", { staticClass: "kzq-top-chart" }, [
                  _c("div", { staticClass: "box-left" }, [
                    _c("div", {
                      staticClass: "pond-name",
                      domProps: { textContent: _vm._s(_vm.pondInfo.poolName) }
                    }),
                    _c("div", { staticClass: "pond-controller-box" }, [
                      _c("div", { staticClass: "controller-item" }, [
                        _c("img", {
                          attrs: {
                            src: _vm.ossHost + "img/gov_icon3.png",
                            alt: ""
                          }
                        }),
                        _c("div", { staticClass: "controller-count" }, [
                          _c(
                            "b",
                            { staticClass: "count zhenyan-node" },
                            [
                              _c("animate-number", {
                                key: _vm.pondInfo.serverOpenTimes,
                                ref: "serverOpenTimes",
                                attrs: {
                                  from: "0",
                                  to: _vm.pondInfo.serverOpenTimes,
                                  duration: _vm.duration,
                                  easing: "easeOutQuad"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v("次 ")
                        ]),
                        _c("div", { staticClass: "item-text" }, [
                          _vm._v("远程开关")
                        ])
                      ]),
                      _c("div", { staticClass: "controller-item" }, [
                        _c("img", {
                          attrs: {
                            src: _vm.ossHost + "img/gov_icon2.png",
                            alt: ""
                          }
                        }),
                        _c("div", { staticClass: "controller-count" }, [
                          _c(
                            "b",
                            { staticClass: "count zhenyan-node" },
                            [
                              _c("animate-number", {
                                key: _vm.pondInfo.timingOpenTimes,
                                ref: "timingOpenTimes",
                                attrs: {
                                  from: "0",
                                  to: _vm.pondInfo.timingOpenTimes,
                                  duration: _vm.duration,
                                  easing: "easeOutQuad"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v("次 ")
                        ]),
                        _c("div", { staticClass: "item-text" }, [
                          _vm._v("定时开关")
                        ])
                      ]),
                      _c("div", { staticClass: "controller-item" }, [
                        _c("img", {
                          attrs: {
                            src: _vm.ossHost + "img/gov_icon1.png",
                            alt: ""
                          }
                        }),
                        _c("div", { staticClass: "controller-count" }, [
                          _c(
                            "b",
                            { staticClass: "count zhenyan-node" },
                            [
                              _c("animate-number", {
                                key: _vm.pondInfo.lowOxygenCount,
                                ref: "lowOxygenCount",
                                attrs: {
                                  from: "0",
                                  to: _vm.pondInfo.lowOxygenCount,
                                  duration: _vm.duration,
                                  easing: "easeOutQuad"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v("次 ")
                        ]),
                        _c("div", { staticClass: "item-text" }, [
                          _vm._v("低氧告警")
                        ])
                      ])
                    ])
                  ]),
                  _c("div", { staticClass: "box-right" }, [
                    _c("div", { staticClass: "ry-info-box" }, [
                      _c("div", { staticClass: "label" }, [_vm._v("当前")]),
                      _c("div", { staticClass: "ry-val oxy-val" }, [
                        _vm._v(
                          _vm._s(_vm.pondInfo.ryLineView.oxygen || "-") + " "
                        ),
                        _c("b", [_vm._v("mg/L")])
                      ]),
                      _c("div", { staticClass: "ry-val" }, [
                        _vm._v(
                          _vm._s(_vm.pondInfo.ryLineView.temperature || "-")
                        ),
                        _c("b", [_vm._v("°C")])
                      ])
                    ]),
                    _c("div", { staticClass: "power-chart-box" }, [
                      _c("div", { staticClass: "chart-title" }, [
                        _vm._v("月度用电量")
                      ]),
                      _c("div", {
                        staticClass: "power-chart-canvas",
                        attrs: { id: "power-chart-box" }
                      }),
                      _vm.showEmptyPowerBox
                        ? _c("div", { staticClass: "empty-box" }, [
                            _vm._v("暂无电量统计")
                          ])
                        : _vm._e()
                    ])
                  ])
                ]),
                _c(
                  "div",
                  {
                    class: {
                      "ry-bottom-chart-box": true,
                      "ph-probe": _vm.isPhProbe
                    }
                  },
                  [
                    _c("div", { staticClass: "ry-chart-box" }, [
                      _c("div", { staticClass: "chart-title" }, [
                        _vm._v("溶氧")
                      ]),
                      _c("div", {
                        staticClass: "ry-chart-canvas",
                        attrs: { id: "ry-chart-box" }
                      }),
                      _vm.showEmptyOxygenBox
                        ? _c("div", { staticClass: "empty-box" }, [
                            _vm._v("暂无溶氧数据")
                          ])
                        : _vm._e()
                    ]),
                    _c("div", { staticClass: "temp-chart-box" }, [
                      _c("div", { staticClass: "chart-title" }, [
                        _vm._v("水温")
                      ]),
                      _c("div", {
                        staticClass: "temp-chart-canvas",
                        attrs: { id: "temp-chart-box" }
                      }),
                      _vm.showEmptyOxygenBox
                        ? _c("div", { staticClass: "empty-box" }, [
                            _vm._v("暂无水温数据")
                          ])
                        : _vm._e()
                    ]),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.isPhProbe,
                            expression: "isPhProbe"
                          }
                        ],
                        staticClass: "ph-chart-box"
                      },
                      [
                        _c("div", { staticClass: "chart-title" }, [
                          _vm._v("pH")
                        ]),
                        _c("div", {
                          staticClass: "ph-chart-canvas",
                          attrs: { id: "ph-chart-box" }
                        }),
                        _vm.showEmptyOxygenBox
                          ? _c("div", { staticClass: "empty-box" }, [
                              _vm._v("暂无pH数据")
                            ])
                          : _vm._e()
                      ]
                    )
                  ]
                )
              ])
            ]
          )
        ])
      ])
    ]),
    _c("div", { staticClass: "page-footer" }, [
      _c("div", { staticClass: "log-box" }, [
        _c("img", {
          attrs: { src: _vm.ossHost + "img/weixin_qrcode.png", alt: "" }
        }),
        _c("div", [_vm._v("请使用微信扫码了解更多")])
      ]),
      _c("div", { staticClass: "code-box" }, [
        _c("img", {
          attrs: { src: _vm.ossHost + "img/big_screen_logo.png", alt: "" }
        })
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "info-title" }, [
      _c("div", [_vm._v("区域")]),
      _c("div", [_vm._v("概况")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "info-item-chart" }, [
      _c("div", { attrs: { id: "canvas-count-box" } })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "info-title" }, [
      _c("div", [_vm._v("塘口")]),
      _c("div", [_vm._v("情况")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }